/** Puanlama formülü oluştur / düzenle — panel açık tema */

import { PANEL } from "./panelTokens";

export const panelFormulaTemplateSectionSx = {
  p: { xs: 1.75, md: 2 },
  mb: 2.5,
  borderRadius: PANEL.radius.cardMd,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
};

export const panelFormulaTemplateGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
  gap: 1.25,
  mt: 1.25,
};

export const panelFormulaTemplateCardSx = (selected = false) => ({
  p: 1.5,
  textAlign: "left",
  borderRadius: PANEL.radius.input,
  bgcolor: selected ? PANEL.accent.soft : PANEL.surface,
  border: `1px solid ${selected ? PANEL.accent.softBorder : PANEL.border}`,
  cursor: "pointer",
  transition: "border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
  boxShadow: selected ? PANEL.accent.shadow25 : "none",
  "&:hover": {
    borderColor: PANEL.accent.softBorder,
    bgcolor: selected ? PANEL.accent.soft18 : PANEL.fill.subtle,
    boxShadow: PANEL.shadow.card,
  },
});

export const panelFormulaTemplateNameSx = {
  fontWeight: 700,
  fontSize: "0.8125rem",
  color: PANEL.text.primary,
  lineHeight: 1.35,
  mb: 0.35,
};

export const panelFormulaTemplateExprSx = {
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  fontSize: "0.72rem",
  color: PANEL.accent.text,
  fontWeight: 600,
  wordBreak: "break-all",
};

export const panelFormulaExpressionFieldSx = {
  maxWidth: { xs: "100%", md: 560 },
  "& .MuiOutlinedInput-root": {
    bgcolor: PANEL.surface,
    borderRadius: PANEL.radius.input,
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: "0.875rem",
    alignItems: "flex-start",
    "& fieldset": { borderColor: PANEL.border },
    "&:hover fieldset": { borderColor: PANEL.fill.hover },
    "&.Mui-focused fieldset": {
      borderColor: PANEL.accent.main,
      boxShadow: `0 0 0 3px ${PANEL.accent.focusRing}`,
    },
  },
  "& textarea": {
    lineHeight: 1.55,
    minHeight: 64,
    maxHeight: 140,
  },
};

export const panelFormulaTestResultSx = (valid) => ({
  mt: 2,
  p: 1.75,
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${valid ? PANEL.accent.softBorder : PANEL.danger.border}`,
  bgcolor: valid ? PANEL.accent.soft : PANEL.danger.soft,
});

export const panelFormulaVariablesPanelSx = {
  p: { xs: 1.75, md: 2 },
  borderRadius: PANEL.radius.cardMd,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
  position: { lg: "sticky" },
  top: { lg: 16 },
  maxHeight: { lg: "calc(100vh - 120px)" },
  overflowY: "auto",
};

export const panelFormulaVariableAccordionSx = {
  mb: 1,
  bgcolor: PANEL.fill.muted,
  borderRadius: `${PANEL.radius.input} !important`,
  border: `1px solid ${PANEL.border}`,
  boxShadow: "none",
  "&:before": { display: "none" },
  overflow: "hidden",
};

export const panelFormulaVariableChipSx = (tone = "blue") => {
  const tones = {
    blue: {
      bg: PANEL.blue.soft12,
      color: PANEL.blue.text,
      border: PANEL.blue.soft25,
      hover: PANEL.blue.soft25,
    },
    green: {
      bg: PANEL.accent.soft12,
      color: PANEL.accent.text,
      border: PANEL.accent.softBorder22,
      hover: PANEL.accent.soft18,
    },
    red: {
      bg: PANEL.danger.soft,
      color: PANEL.danger.text,
      border: PANEL.danger.border,
      hover: "rgba(239, 68, 68, 0.14)",
    },
    grey: {
      bg: PANEL.fill.muted,
      color: PANEL.text.body,
      border: PANEL.border,
      hover: PANEL.fill.hoverAlt,
    },
  };
  const t = tones[tone] || tones.blue;
  return {
    bgcolor: t.bg,
    color: t.color,
    border: `1px solid ${t.border}`,
    fontWeight: 600,
    fontSize: "0.75rem",
    cursor: "pointer",
    "&:hover": { bgcolor: t.hover },
  };
};

export const panelFormulaActionsSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1.5,
  mt: 3,
  pt: 2.5,
  borderTop: `1px solid ${PANEL.border}`,
};

export const panelFormulaViewSectionSx = {
  px: { xs: 2, md: 2.5 },
  py: 2,
  borderBottom: `1px solid ${PANEL.border}`,
  "&:last-child": { borderBottom: "none" },
};

export const panelFormulaViewSectionHeaderSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 1.25,
};

export const panelFormulaViewSectionTitleSx = {
  fontWeight: 700,
  fontSize: "0.9rem",
  color: PANEL.text.primary,
};

export const panelFormulaViewExpressionBoxSx = {
  p: 2,
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  fontSize: "0.9375rem",
  fontWeight: 600,
  color: PANEL.accent.text,
  overflowX: "auto",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  lineHeight: 1.6,
};

export const panelFormulaViewHelpPaperSx = (tone = "blue") => {
  const tones = {
    blue: { border: PANEL.blue.soft25, bg: PANEL.blue.soft12 },
    green: { border: PANEL.accent.softBorder22, bg: PANEL.accent.soft12 },
    red: { border: PANEL.danger.border, bg: PANEL.danger.soft },
  };
  const toneStyle = tones[tone] || tones.blue;
  return {
    p: 2,
    mb: 1.5,
    borderRadius: PANEL.radius.cardSm,
    bgcolor: toneStyle.bg,
    border: `1px solid ${toneStyle.border}`,
    "&:last-child": { mb: 0 },
  };
};

export const panelFormulaViewHelpExampleSx = (tone = "blue") => ({
  pl: 1.25,
  borderLeft: `3px solid ${
    tone === "green" ? PANEL.accent.main : tone === "red" ? PANEL.danger.main : PANEL.blue.main
  }`,
  mb: 0.75,
  color: PANEL.text.body,
  fontSize: "0.8125rem",
  lineHeight: 1.55,
});

export const panelFormulaViewInfoAlertSx = {
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.blue.soft12,
  border: `1px solid ${PANEL.blue.soft25}`,
  color: PANEL.text.body,
  "& .MuiAlert-icon": { color: PANEL.blue.text },
};
